import { DocumentNode, gql } from '@apollo/client';
import { HStack, Image, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { Card } from '@/imports/ui/chakra/components/Card';
import { ImageFallback } from '@/imports/ui/chakra/components/ImageFallback';

import { AdditionalSponsorsCard_SimpleEventFragment } from './graphql-types/AdditionalSponsorsCard_SimpleEventFragment';

export const AdditionalSponsorsCard: React.FC<{
  simpleEvent: AdditionalSponsorsCard_SimpleEventFragment;
}> & { simpleEventFragment: DocumentNode } = ({ simpleEvent }) => {
  if (!simpleEvent.simpleEventSponsors?.additionalSponsors?.length) {
    return null;
  }

  return (
    <Card py="6" px="4">
      <Stack spacing="3">
        <Text textStyle="compactStrong" color="gray.600">
          ADDITIONAL SPONSORS
        </Text>

        <Stack spacing="3">
          {simpleEvent.simpleEventSponsors.additionalSponsors.map((sponsor) => {
            return (
              <NextLink key={sponsor._id} href={`/companies/${sponsor._id}`}>
                <Card
                  p="4"
                  shadow="xs"
                  _hover={{ bg: 'gray.50' }}
                  cursor="pointer"
                >
                  <HStack spacing="4">
                    <Image
                      boxSize="48px"
                      src={sponsor.profilePicture?.imageProxy ?? undefined}
                      alt={sponsor.name}
                      borderRadius="sm"
                      fallback={
                        <ImageFallback borderRadius="sm" boxSize="48px" />
                      }
                    />

                    <Text textStyle="bodyStrong" noOfLines={1}>
                      {sponsor.name}
                    </Text>
                  </HStack>
                </Card>
              </NextLink>
            );
          })}
        </Stack>
      </Stack>
    </Card>
  );
};

AdditionalSponsorsCard.simpleEventFragment = gql`
  fragment AdditionalSponsorsCard_SimpleEventFragment on SimpleEventV2 {
    _id
    simpleEventSponsors {
      additionalSponsors {
        ... on Organization {
          _id
          name
          profilePicture {
            imageProxy(input: { h: 40, w: 40, fit: "crop" })
          }
        }
      }
    }
  }
`;
